import { render, staticRenderFns } from "./TargetLabelFlow.vue?vue&type=template&id=4010abf4&scoped=true&"
import script from "./TargetLabelFlow.vue?vue&type=script&lang=js&"
export * from "./TargetLabelFlow.vue?vue&type=script&lang=js&"
import style0 from "./TargetLabelFlow.vue?vue&type=style&index=0&id=4010abf4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4010abf4",
  null
  
)

export default component.exports